import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { id: "PatientInfo__Main" }
const _hoisted_2 = { class: "header-row align-items-center fw-bold" }
const _hoisted_3 = { class: "fw-bold user-name font-size-xl me-2" }
const _hoisted_4 = { class: "fw-bold mt-sm-1 user-mrn" }
const _hoisted_5 = { class: "header-row fw-bold font-size-xs" }
const _hoisted_6 = { class: "header-cell" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "text-default"
}
const _hoisted_9 = { class: "header-cell" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", {
  class: /*#__PURE__*/_normalizeClass(`fas fa-circle header-divider `)
}, null, -1 /* HOISTED */)
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  class: "text-default"
}
const _hoisted_13 = {
  key: 0,
  class: "header-cell"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", {
  class: /*#__PURE__*/_normalizeClass(`fas fa-circle header-divider `)
}, null, -1 /* HOISTED */)
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 1,
  class: "text-default"
}
const _hoisted_17 = {
  key: 1,
  class: "header-cell"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", {
  class: /*#__PURE__*/_normalizeClass(`fas fa-circle header-divider `)
}, null, -1 /* HOISTED */)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, " Veteran ", -1 /* HOISTED */)
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = { class: "header-cell" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", {
  class: /*#__PURE__*/_normalizeClass(`fas fa-circle header-divider `)
}, null, -1 /* HOISTED */)
const _hoisted_23 = {
  key: 0,
  class: "badge badge-warning"
}
const _hoisted_24 = {
  key: 1,
  class: "badge CodeStatus__Red",
  tooltip: "title: Do Not Resuscitate"
}
const _hoisted_25 = {
  key: 2,
  class: "badge CodeStatus__Red",
  tooltip: "title: Do Not Intubate"
}
const _hoisted_26 = {
  key: 3,
  class: "badge CodeStatus__Red",
  tooltip: "title: Do Not Hospitalize"
}
const _hoisted_27 = {
  key: 4,
  class: "badge CodeStatus__Green"
}
const _hoisted_28 = {
  key: 5,
  class: "badge CodeStatus__Red",
  tooltip: "title: Other Code Status"
}
const _hoisted_29 = {
  key: 2,
  class: "header-cell"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", {
  class: /*#__PURE__*/_normalizeClass(`fas fa-circle header-divider `)
}, null, -1 /* HOISTED */)
const _hoisted_31 = {
  key: 3,
  class: "header-cell"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", {
  class: /*#__PURE__*/_normalizeClass(`fas fa-circle header-divider `)
}, null, -1 /* HOISTED */)
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Tags ")
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = {
  key: 4,
  class: "header-cell"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", {
  class: /*#__PURE__*/_normalizeClass(`fas fa-circle header-divider `)
}, null, -1 /* HOISTED */)
const _hoisted_37 = ["href"]
const _hoisted_38 = { class: "header-row fw-bold font-size-xs" }
const _hoisted_39 = { class: "header-cell" }
const _hoisted_40 = ["href"]
const _hoisted_41 = {
  key: 1,
  class: "text-default"
}
const _hoisted_42 = { class: "header-cell" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("i", {
  class: /*#__PURE__*/_normalizeClass(`fas fa-circle header-divider `)
}, null, -1 /* HOISTED */)
const _hoisted_44 = ["href"]
const _hoisted_45 = {
  key: 1,
  class: "text-default"
}
const _hoisted_46 = {
  class: "header-cell",
  tooltip: { title: `Patient's Date of Birth` }
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("i", {
  class: /*#__PURE__*/_normalizeClass(`fas fa-circle header-divider `)
}, null, -1 /* HOISTED */)
const _hoisted_48 = { key: 0 }
const _hoisted_49 = {
  key: 1,
  class: "text-default"
}
const _hoisted_50 = {
  id: "headerDeskInfo",
  class: "header-row mt-1"
}
const _hoisted_51 = {
  key: 0,
  class: "information-column d-flex flex-column me-4"
}
const _hoisted_52 = { class: "information-cell" }
const _hoisted_53 = { class: "title text-nowrap" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("b", null, "Benefit Period Details", -1 /* HOISTED */)
const _hoisted_55 = ["href"]
const _hoisted_56 = { key: 1 }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", { class: "text-default" }, "Pending", -1 /* HOISTED */)
const _hoisted_58 = [
  _hoisted_57
]
const _hoisted_59 = { key: 2 }
const _hoisted_60 = { class: "text-nowrap" }
const _hoisted_61 = {
  key: 0,
  class: "badge badge-light me-2"
}
const _hoisted_62 = { key: 1 }
const _hoisted_63 = { key: 0 }
const _hoisted_64 = { key: 1 }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("span", { class: "mx-auto" }, "-", -1 /* HOISTED */)
const _hoisted_66 = {
  key: 2,
  class: "text-default"
}
const _hoisted_67 = { class: "information-cell" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("b", { class: "title" }, "Attending Physician", -1 /* HOISTED */)
const _hoisted_69 = { key: 0 }
const _hoisted_70 = {
  key: 1,
  class: "text-default"
}
const _hoisted_71 = { class: "information-column d-flex flex-column me-4" }
const _hoisted_72 = { class: "information-cell" }
const _hoisted_73 = { class: "title" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("b", { class: "title" }, "Admission Date", -1 /* HOISTED */)
const _hoisted_75 = ["href"]
const _hoisted_76 = { key: 0 }
const _hoisted_77 = { key: 1 }
const _hoisted_78 = { class: "text-default" }
const _hoisted_79 = {
  key: 0,
  class: "information-cell"
}
const _hoisted_80 = /*#__PURE__*/_createElementVNode("b", { class: "title" }, "Medicare Number", -1 /* HOISTED */)
const _hoisted_81 = { key: 0 }
const _hoisted_82 = {
  key: 0,
  class: "fas fa-check-circle ready text-success align-self-center ms-1"
}
const _hoisted_83 = {
  key: 1,
  class: "fas fa-times-circle warn text-danger ms-1 align-self-center ms-1"
}
const _hoisted_84 = {
  key: 1,
  class: "text-default"
}
const _hoisted_85 = {
  key: 1,
  class: "information-cell"
}
const _hoisted_86 = { class: "title" }
const _hoisted_87 = { class: "d-flex" }
const _hoisted_88 = {
  key: 1,
  class: "information-column h-100 d-flex flex-column me-4"
}
const _hoisted_89 = { class: "information-cell" }
const _hoisted_90 = { class: "title" }
const _hoisted_91 = { key: 0 }
const _hoisted_92 = /*#__PURE__*/_createTextVNode("Diagnosis")
const _hoisted_93 = {
  key: 0,
  class: "text-truncate"
}
const _hoisted_94 = {
  key: 1,
  class: "text-default"
}
const _hoisted_95 = { class: "information-cell" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("b", { class: "title" }, "Medicaid Number", -1 /* HOISTED */)
const _hoisted_97 = { key: 0 }
const _hoisted_98 = {
  key: 1,
  class: "text-default"
}
const _hoisted_99 = {
  key: 2,
  class: "information-column h-100 me-4"
}
const _hoisted_100 = { class: "information-cell" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("b", { class: "title" }, "Diagnosis", -1 /* HOISTED */)
const _hoisted_102 = {
  key: 0,
  class: "text-truncate"
}
const _hoisted_103 = {
  key: 1,
  class: "text-default"
}
const _hoisted_104 = { class: "information-cell" }
const _hoisted_105 = /*#__PURE__*/_createElementVNode("b", { class: "title" }, "Palliative Provider", -1 /* HOISTED */)
const _hoisted_106 = { key: 0 }
const _hoisted_107 = {
  key: 1,
  class: "text-default"
}
const _hoisted_108 = { class: "information-column h-100" }
const _hoisted_109 = {
  key: 0,
  class: "information-cell"
}
const _hoisted_110 = /*#__PURE__*/_createElementVNode("b", { class: "title" }, "Discharge Date", -1 /* HOISTED */)
const _hoisted_111 = { key: 0 }
const _hoisted_112 = {
  key: 1,
  class: "text-default"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmptyTextHandler = _resolveComponent("EmptyTextHandler")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, [
          _createElementVNode("a", {
            href: "javascript:void(0);",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handlePatientNameClick()))
          }, _toDisplayString(_ctx.formatName(
                                _ctx.selectedPatientDetails.firstName,
                                _ctx.selectedPatientDetails.lastName,
                                "FN LN",
                                "",
                                _ctx.selectedPatientDetails.middleInitial
                            )), 1 /* TEXT */)
        ]),
        _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_4, [
          _createTextVNode(_toDisplayString(_ctx.selectedPatientDetails.medicalRecordNumber), 1 /* TEXT */)
        ])), [
          [_directive_tooltip, { title: 'Medical Record Number (MRN)' }]
        ])
      ]),
      _createElementVNode("section", _hoisted_5, [
        _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_6, [
          (_ctx.selectedPatientDetails.gender)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.genderEnum.getDescriptionUsingValue(_ctx.selectedPatientDetails.gender)), 1 /* TEXT */))
            : (_openBlock(), _createElementBlock("span", _hoisted_8, "No Gender Selected"))
        ])), [
          [_directive_tooltip, { title: 'Sex' }]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_9, [
          _hoisted_10,
          (_ctx.age)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.age), 1 /* TEXT */))
            : (_openBlock(), _createElementBlock("span", _hoisted_12, "Age not available"))
        ])), [
          [_directive_tooltip, { title: `Patient's Age` }]
        ]),
        (!_ctx.isPalliativeCare)
          ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_13, [
              _hoisted_14,
              (_ctx.selectedPatientDetails.levelOfCare)
                ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.levelOfCareEnum.getDescriptionUsingValue(_ctx.selectedPatientDetails.levelOfCare)), 1 /* TEXT */))
                : (_openBlock(), _createElementBlock("span", _hoisted_16, "No Level of Care Selected"))
            ])), [
              [_directive_tooltip, { title: `Level of Care` }]
            ])
          : _createCommentVNode("v-if", true),
        (_ctx.veteranLabel)
          ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_17, _hoisted_20)), [
              [_directive_tooltip, { title: _ctx.veteranLabel }]
            ])
          : _createCommentVNode("v-if", true),
        _createElementVNode("span", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("div", null, [
            (_ctx.selectedPatientDetails.isHospitalized)
              ? (_openBlock(), _createElementBlock("span", _hoisted_23, " Hospitalized "))
              : _createCommentVNode("v-if", true),
            (_ctx.isDoNotResuscitate)
              ? (_openBlock(), _createElementBlock("span", _hoisted_24, "DNR"))
              : _createCommentVNode("v-if", true),
            (_ctx.isDoNotIntubate)
              ? (_openBlock(), _createElementBlock("span", _hoisted_25, " DNI "))
              : _createCommentVNode("v-if", true),
            (_ctx.isDoNotHospitalize)
              ? (_openBlock(), _createElementBlock("span", _hoisted_26, " DNH "))
              : _createCommentVNode("v-if", true),
            (!_ctx.isDoNotResuscitate && !_ctx.isDoNotIntubate && !_ctx.isDoNotHospitalize)
              ? (_openBlock(), _createElementBlock("span", _hoisted_27, " Full Code "))
              : _createCommentVNode("v-if", true),
            (!!_ctx.selectedPatientDetails.other)
              ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.selectedPatientDetails.other), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ])
        ]),
        (!!_ctx.selectedPatientDetails.facilityName)
          ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
              _hoisted_30,
              _createTextVNode(" " + _toDisplayString(_ctx.selectedPatientDetails.facilityName), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true),
        (_ctx.isTagsEnabled && _ctx.patientTags)
          ? (_openBlock(), _createElementBlock("span", _hoisted_31, [
              _hoisted_32,
              _withDirectives((_openBlock(), _createElementBlock("span", null, _hoisted_34)), [
                [_directive_tooltip, { title: `${_ctx.patientTags}` }]
              ])
            ]))
          : _createCommentVNode("v-if", true),
        (!_ctx.isPalliativeCare)
          ? (_openBlock(), _createElementBlock("span", _hoisted_35, [
              _hoisted_36,
              _createElementVNode("a", {
                href: `/patients/allergy-profile/${_ctx.selectedPatientDetails.id}?status=${_ctx.selectedPatientDetails.status}`,
                class: "font-size-xs font-weight-bold text-danger"
              }, _toDisplayString(_ctx.allergyCount > 0 ? `Allergies (${_ctx.allergyCount})` : "No Known Allergies"), 9 /* TEXT, PROPS */, _hoisted_37)
            ]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" <span class=\"header-cell\" v-if=\"isPalliativeCare || patientSpecialtyPrograms\">\r\n                    <i class=\"fas fa-circle header-divider\"></i>\r\n\r\n                    <span v-tooltip=\"{ title: `${patientSpecialtyPrograms}` }\"> Specialty Program </span>\r\n                </span> ")
      ]),
      _createElementVNode("section", _hoisted_38, [
        _withDirectives((_openBlock(), _createElementBlock("section", _hoisted_39, [
          _createElementVNode("i", {
            class: _normalizeClass(`fas fa-map-marker-alt me-1 text-app-secondary-${_ctx.isPalliativeCare ? 'pal' : 'hos'}`)
          }, null, 2 /* CLASS */),
          (_ctx.hasAddress)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: _ctx.patientAddressLink,
                target: "_blank"
              }, _toDisplayString(_ctx.displayAddress), 9 /* TEXT, PROPS */, _hoisted_40))
            : (_openBlock(), _createElementBlock("span", _hoisted_41, "Address Not Available"))
        ])), [
          [_directive_tooltip, { title: `Patient's Address` }]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("section", _hoisted_42, [
          _hoisted_43,
          _createElementVNode("i", {
            class: _normalizeClass(`fas fa-phone-square me-1 text-app-secondary-${_ctx.isPalliativeCare ? 'pal' : 'hos'}`)
          }, null, 2 /* CLASS */),
          (_ctx.selectedPatientDetails.preferredPhone)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: `tel: ${_ctx.selectedPatientDetails.preferredPhone}`
              }, _toDisplayString(_ctx.formatPhoneNumber(_ctx.selectedPatientDetails.preferredPhone)), 9 /* TEXT, PROPS */, _hoisted_44))
            : (_openBlock(), _createElementBlock("span", _hoisted_45, "Phone Not Available"))
        ])), [
          [_directive_tooltip, { title: `Patient's Phone Number` }]
        ]),
        _createElementVNode("section", _hoisted_46, [
          _hoisted_47,
          _createElementVNode("i", {
            class: _normalizeClass(`fas fa-birthday-cake me-1 text-app-secondary-${_ctx.isPalliativeCare ? 'pal' : 'hos'}`)
          }, null, 2 /* CLASS */),
          (_ctx.selectedPatientDetails.dateOfBirth)
            ? (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(_ctx.formatDate(_ctx.selectedPatientDetails.dateOfBirth)), 1 /* TEXT */))
            : (_openBlock(), _createElementBlock("span", _hoisted_49, "D.O.B Not Available"))
        ])
      ]),
      _createElementVNode("section", _hoisted_50, [
        (!_ctx.isPalliativeCare)
          ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
              _createElementVNode("section", _hoisted_52, [
                _createElementVNode("header", _hoisted_53, [
                  _hoisted_54,
                  (!_ctx.isPendingPatient && _ctx.canShowBenefitPeriodManager)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: `/patients/benefit-period-manager/${_ctx.selectedPatientDetails.id}?status=${_ctx.selectedPatientDetails.status}`,
                        class: "font-size-xs ms-2 font-weight-bold"
                      }, " View ", 8 /* PROPS */, _hoisted_55))
                    : _createCommentVNode("v-if", true),
                  (_ctx.isPendingPatient)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_56, _hoisted_58))
                    : (_openBlock(), _createElementBlock("span", _hoisted_59, [
                        _createElementVNode("div", _hoisted_60, [
                          (_ctx.selectedPatientDetails.benefitPeriodNumber)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_61, "# " + _toDisplayString(_ctx.selectedPatientDetails.benefitPeriodNumber), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                          (
                                            (_ctx.selectedPatientDetails.benefitPeriodStartDate ||
                                                _ctx.selectedPatientDetails.transferBenefitPeriodStartDate) &&
                                            _ctx.selectedPatientDetails.benefitPeriodEndDate
                                        )
                            ? (_openBlock(), _createElementBlock("span", _hoisted_62, [
                                (_ctx.selectedPatientDetails.isTransfer)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_63, _toDisplayString(_ctx.formatDate(_ctx.selectedPatientDetails.transferBenefitPeriodStartDate)), 1 /* TEXT */))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_64, _toDisplayString(_ctx.formatDate(_ctx.selectedPatientDetails.benefitPeriodStartDate)), 1 /* TEXT */)),
                                _hoisted_65,
                                _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(_ctx.selectedPatientDetails.benefitPeriodEndDate)), 1 /* TEXT */)
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_66, "Not Available"))
                        ])
                      ]))
                ])
              ]),
              _createElementVNode("section", _hoisted_67, [
                _hoisted_68,
                (_ctx.selectedPatientDetails.attendingPhysicianName)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_69, _toDisplayString(_ctx.selectedPatientDetails.attendingPhysicianName), 1 /* TEXT */))
                  : (_openBlock(), _createElementBlock("span", _hoisted_70, "Not Available"))
              ])
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_71, [
          _createElementVNode("section", _hoisted_72, [
            _createElementVNode("header", _hoisted_73, [
              _hoisted_74,
              (!_ctx.isPendingPatient && _ctx.canShowBenefitPeriodManager && _ctx.isPalliativeCare)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: `/patients/admission-period-manager/${_ctx.selectedPatientDetails.id}?status=${_ctx.selectedPatientDetails.status}`,
                    class: "font-size-xs ms-2 font-weight-bold"
                  }, " View ", 8 /* PROPS */, _hoisted_75))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("div", null, [
              (_ctx.selectedPatientDetails.admissionDate)
                ? (_openBlock(), _createElementBlock("span", _hoisted_76, _toDisplayString(_ctx.formatDate(_ctx.selectedPatientDetails.admissionDate)), 1 /* TEXT */))
                : (_openBlock(), _createElementBlock("div", _hoisted_77, [
                    _createElementVNode("span", _hoisted_78, _toDisplayString(_ctx.isPendingPatient ? "Pending" : "Not Available"), 1 /* TEXT */)
                  ]))
            ])
          ]),
          (!_ctx.isPalliativeCare)
            ? (_openBlock(), _createElementBlock("section", _hoisted_79, [
                _hoisted_80,
                _createElementVNode("div", null, [
                  (_ctx.selectedPatientDetails.medicareBeneficiaryIdentification)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_81, [
                        _createTextVNode(_toDisplayString(_ctx.selectedPatientDetails.medicareBeneficiaryIdentification) + " ", 1 /* TEXT */),
                        (_ctx.selectedPatientDetails.isPayerVerified)
                          ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_82, null, 512 /* NEED_PATCH */)), [
                              [_directive_tooltip, { title: `Benefits have been verified for this payer.` }]
                            ])
                          : _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_83, null, 512 /* NEED_PATCH */)), [
                              [_directive_tooltip, { title: `Benefits have not been verified for this payer.` }]
                            ])
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_84, "Not Available"))
                ])
              ]))
            : _createCommentVNode("v-if", true),
          (_ctx.isPalliativeCare)
            ? (_openBlock(), _createElementBlock("section", _hoisted_85, [
                _createElementVNode("b", _hoisted_86, _toDisplayString(_ctx.selectedPatientDetails.primaryPayor?.PayorName), 1 /* TEXT */),
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_87, [
                    _createVNode(_component_EmptyTextHandler, {
                      text: _ctx.selectedPatientDetails.primaryPayor?.MemberId
                    }, null, 8 /* PROPS */, ["text"]),
                    _withDirectives(_createElementVNode("span", {
                      class: _normalizeClass(`text-center fas ${_ctx.selectedPatientDetails.primaryPayor?.IsBenefitVerified ? 'fa-check-circle text-success' : 'fa-times-circle text-danger'} ms-1`)
                    }, null, 2 /* CLASS */), [
                      [_directive_tooltip, {
                                        title: `${_ctx.selectedPatientDetails.primaryPayor?.IsBenefitVerified ? 'Benefits have been verified for this payer.' : 'Benefits have not been verified for this payer.'}  
                            `
                                    }]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        (!_ctx.isPalliativeCare)
          ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
              _createElementVNode("section", _hoisted_89, [
                _createElementVNode("b", _hoisted_90, [
                  (!_ctx.isPalliativeCare)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_91, "Terminal "))
                    : _createCommentVNode("v-if", true),
                  _hoisted_92
                ]),
                _createElementVNode("div", null, [
                  (!!_ctx.terminalDiagnosis)
                    ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_93, [
                        _createTextVNode(_toDisplayString(_ctx.terminalDiagnosis.description), 1 /* TEXT */)
                      ])), [
                        [_directive_tooltip, { title: `${_ctx.terminalDiagTooltip}` }]
                      ])
                    : (_openBlock(), _createElementBlock("span", _hoisted_94, "Not Available"))
                ])
              ]),
              _createElementVNode("section", _hoisted_95, [
                _hoisted_96,
                _createElementVNode("div", null, [
                  (_ctx.medicaidLabel)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_97, _toDisplayString(_ctx.medicaidLabel), 1 /* TEXT */))
                    : (_openBlock(), _createElementBlock("span", _hoisted_98, "Not Available"))
                ])
              ])
            ]))
          : _createCommentVNode("v-if", true),
        (_ctx.isPalliativeCare)
          ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
              _createElementVNode("section", _hoisted_100, [
                _hoisted_101,
                _createElementVNode("div", null, [
                  (!!_ctx.terminalDiagnosis)
                    ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_102, [
                        _createTextVNode(_toDisplayString(_ctx.terminalDiagnosis.description), 1 /* TEXT */)
                      ])), [
                        [_directive_tooltip, { title: `${_ctx.terminalDiagTooltip}` }]
                      ])
                    : (_openBlock(), _createElementBlock("span", _hoisted_103, "Not Available"))
                ])
              ]),
              _createElementVNode("section", _hoisted_104, [
                _hoisted_105,
                _createElementVNode("div", null, [
                  (_ctx.selectedPatientDetails.attendingPhysicianName)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_106, _toDisplayString(_ctx.selectedPatientDetails.attendingPhysicianName), 1 /* TEXT */))
                    : (_openBlock(), _createElementBlock("span", _hoisted_107, "Not Available"))
                ])
              ])
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_108, [
          (_ctx.isDischarged)
            ? (_openBlock(), _createElementBlock("section", _hoisted_109, [
                _hoisted_110,
                _createElementVNode("div", null, [
                  (_ctx.selectedPatientDetails.dischargeDate)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_111, _toDisplayString(_ctx.formatDate(_ctx.selectedPatientDetails.dischargeDate)), 1 /* TEXT */))
                    : (_openBlock(), _createElementBlock("span", _hoisted_112, "Not Available"))
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ])
  ]))
}